// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"_13CBG","titleSection":"_2jJsB","controls":"_1h2uw","gridWidthSection":"_1R_K5"};